import { render, staticRenderFns } from "./TournamentCoachesPanel.vue?vue&type=template&id=7a12e360&"
import script from "./TournamentCoachesPanel.vue?vue&type=script&lang=js&"
export * from "./TournamentCoachesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports